import { gapBadgeClass } from "../../Utils/Helper/discoveryHubUi";

type Props = {
  gap?: string | null;
};

const GapBadge = ({ gap }: Props) => {
  if (!gap) {
    return <span className="text-gray-400">—</span>;
  }
  if (gap === "Aligned-High") {
    return (
      <span
        className={gapBadgeClass("aligned")}
        title="Sponsor and Account Team ratings are both strong"
      >
        ✓ Aligned
      </span>
    );
  }
  if (gap === "Insufficient") {
    return (
      <span
        className={gapBadgeClass("insufficient")}
        title="Poll 2 not submitted — gap cannot be calculated"
      >
        Insufficient
      </span>
    );
  }
  if (gap === "Over-claim") {
    return (
      <span
        className={gapBadgeClass("warn")}
        title="Sponsor self-report higher than Account Team feedback"
      >
        ⚠ Over
      </span>
    );
  }
  if (gap === "Under-report") {
    return (
      <span
        className={gapBadgeClass("warn")}
        title="Account Team feedback higher than Sponsor self-report"
      >
        ⚠ Under
      </span>
    );
  }
  if (gap === "At-risk") {
    return (
      <span
        className={gapBadgeClass("risk")}
        title="Both Poll 1 and Poll 2 indicate engagement risk"
      >
        🚩 Risk
      </span>
    );
  }
  return <span className="text-gray-400">{gap}</span>;
};

export default GapBadge;
